"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.toastr = exports.reducer = exports.actions = exports["default"] = void 0;

var _ReduxToastr = _interopRequireDefault(require("./ReduxToastr"));

var ReduxToastrActions = _interopRequireWildcard(require("./actions"));

var _reducer = _interopRequireDefault(require("./reducer"));

var _toastrEmitter = require("./toastrEmitter");

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var _default = _ReduxToastr["default"];
exports["default"] = _default;
var actions = ReduxToastrActions;
exports.actions = actions;
var reducer = _reducer["default"];
exports.reducer = reducer;
var toastr = _toastrEmitter.toastrEmitter;
exports.toastr = toastr;


/*****************
 ** WEBPACK FOOTER
 ** ./~/react-redux-toastr/lib/index.js
 ** module id = 42
 ** module chunks = 0
 **/